import { useAuth } from 'apps-common/context/auth';
import { t } from 'translations';

import { FooterContainer } from '../../styles/containers';
import { Row } from '../../styles/layout';
import { FooterParagraph } from '../../styles/text';
import OuraTextLogo from '../assets/oura-text.svg?react';
import { HorizontalLine } from '../HorizontalLine';
import { LogoutButton } from '../LogoutButton';
import { FooterProps } from './types';
import { WebsiteLinks } from './WebsiteLinks';

export const MobileFooter = ({ onLinkClick, showLogout }: FooterProps) => {
  const { logout } = useAuth();

  return (
    <FooterContainer>
      <HorizontalLine />
      <Row $width="100%" $wrap="nowrap">
        <WebsiteLinks onLinkClick={onLinkClick} />
        {showLogout && <LogoutButton onClick={() => logout()} />}
      </Row>

      <FooterParagraph $textAlign="left" $color="grayLightest">
        <OuraTextLogo width="51px" height="16px" />
        <span data-test="footer-year">
          {t('membership_footer_all_rights_reserved_dynamic', {
            year: new Date().getFullYear(),
          })}{' '}
        </span>
      </FooterParagraph>
      <FooterParagraph $textAlign="left" $color="grayLightest">
        {t('membership_footer_trademarks')}{' '}
      </FooterParagraph>
    </FooterContainer>
  );
};
